import TitledText from "@coworker/apprestructured/src/task-management/components/TitledText/TitledText";
import { useUser } from "@coworker/apprestructured/src/shared/hooks/users/useUser";
import { ViewerFragmentCommonProps } from "@coworker/apprestructured/src/task-management/components/TaskViewerSheet/viewer-fragments/ViewerFragment";
import { getByPath } from "@coworker/apprestructured/src/shared/helpers/object.helper";
import { isLoading } from "@coworker/apprestructured/src/task-management/loading";

export type UserNameViewerFragmentConfigProps = {
  title: string;
  field: string;
};

type UserNameViewerFragmentProps = {
  configProps: UserNameViewerFragmentConfigProps;
  commonProps: ViewerFragmentCommonProps;
};

function UserNameViewerFragment({
  configProps,
  commonProps,
}: UserNameViewerFragmentProps) {
  const { field, title } = configProps;
  const { task } = commonProps;
  const uid = getByPath<string>(task, field);
  const { data: user } = useUser(isLoading(uid) ? "" : uid);

  return <TitledText title={title} text={user?.fullName} />;
}

export default UserNameViewerFragment;
